<script>
// Generic per-day bar chart for the external-shipments stakeholder dashboard.
// Unlike BarChart.vue (hard-wired to its report types), this takes plain
// labels/values props so the same component renders orders/day and fee/day.
import {Bar} from "vue-chartjs";

export default {
  extends: Bar,
  props: {
    labels: {type: Array, default: () => []},
    values: {type: Array, default: () => []},
    label: {type: String, default: ''},
    color: {type: String, default: '#E11F26'},
    unit: {type: String, default: ''},
  },
  mounted() {
    this.draw();
  },
  watch: {
    values() {
      this.draw();
    },
  },
  methods: {
    formatNumber(value) {
      const p = Number(value || 0).toFixed(0);
      return p.split("").reverse().reduce(function (acc, ch, i) {
        return ch === "-" ? acc : ch + (i && !(i % 3) ? "," : "") + acc;
      }, "");
    },
    draw() {
      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            label: this.label,
            backgroundColor: this.color,
            data: this.values,
          },
        ],
      }, {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              callback: (value) => this.formatNumber(value) + (this.unit ? ' ' + this.unit : ''),
              fontColor: 'black',
              fontFamily: 'Phetsarath OT',
              fontSize: 10,
            },
          }],
          xAxes: [{
            ticks: {
              fontColor: 'black',
              fontFamily: 'Phetsarath OT',
              fontSize: 10,
              maxRotation: 90,
              minRotation: 45,
              autoSkip: true,
              autoSkipPadding: 8,
            },
          }],
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: (tooltipItems) => this.formatNumber(tooltipItems.yLabel) + (this.unit ? ' ' + this.unit : ''),
          },
          titleFontFamily: 'Phetsarath OT',
          bodyFontFamily: 'Phetsarath OT',
        },
        legend: {
          display: false,
        },
        plugins: {
          // BarChart.vue registers chartjs-plugin-datalabels GLOBALLY — disable it
          // here (a 30-day series turns labels into noise).
          datalabels: {
            display: false,
          },
        },
      });
    },
  },
}
</script>
